// Runtime configuration loader.
//
// In production (nginx container), /config.js is generated at container startup
// by envsubst on config.js.template, using runtime environment variables. In
// local dev (Vite dev server), /config.js is served from apps/viltrapport-web/public/.
// Either way, /config.js sets window.__APP_CONFIG__ before the React bundle
// runs (see index.html).
//
// The bundle therefore has zero environment-specific values compiled in, which
// is what makes per-environment image promotion possible.

export interface FirebaseConfig {
  apiKey: string
  authDomain: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

export interface DatadogConfig {
  applicationId: string
  clientToken: string
  service: string
  env: string
  version: string
}

export interface AppConfig {
  firebase: FirebaseConfig
  apiUrl: string
  // Optional — missing applicationId or clientToken means initDatadog no-ops.
  // The runtime loader does NOT validate datadog fields; absence is a feature
  // so local dev and E2E builds can run without a Datadog RUM application.
  datadog?: DatadogConfig
  // Mirror of fields in domains/clubhouse/viltrapport-web/src/appConfig.ts.
  // Both packages declare Window.__APP_CONFIG__ with their own AppConfig, so
  // the merged global interface must stay structurally identical (TS2717).
  // Chronicle does NOT consume these fields — they belong to clubhouse's
  // TopBarActions component.
  freshdeskUrl?: string
  helpUrl?: string
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig
  }
}

function readAppConfig(): AppConfig {
  const cfg = window.__APP_CONFIG__
  if (!cfg) {
    throw new Error(
      'App config not loaded. Expected /config.js to set window.__APP_CONFIG__ before the bundle ran.',
    )
  }
  if (!cfg.apiUrl) {
    throw new Error('Missing required config field: apiUrl')
  }
  const requiredFirebase: ReadonlyArray<keyof FirebaseConfig> = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId',
  ]
  for (const key of requiredFirebase) {
    if (!cfg.firebase?.[key]) {
      throw new Error(`Missing required firebase config field: ${key}`)
    }
  }
  return cfg
}

export const appConfig: AppConfig = readAppConfig()
